const lottie = require('lottie-web');
const animationJSON = require('../../anim/homepage-animation.json');

/**
 * Homepage Animation component.
 *
 * @param {HTMLElement} homepageHeroElement
 */
export function HomepageAnimation(homepageHeroElement) {
  /**
   * Initialize our component.
   */
  const init = async () => {
    const animationElement = homepageHeroElement.querySelector('#hero-animation');
    const animationPlaceholderElement = homepageHeroElement.querySelector('#hero-animation-placeholder');
    const animation = lottie.loadAnimation({
      container: animationElement,
      loop: false,
      animationData: animationJSON,
    });

    animation.addEventListener('DOMLoaded', () => animationPlaceholderElement.remove());
  };
  init();
}
